import { Component, OnInit } from '@angular/core';
import { BaseService } from '../../base.service';
import { BankListItem } from '../../models/bankListItem';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operator/map';
import { EvaluationService } from '../../services/evaluation.service';
import { EvaluationListItem } from '../../models/evaluationListItem';

@Component({
  selector: 'app-evaluation-list',
  templateUrl: './evaluation-list.component.html',
  styleUrls: [ ]
})

export class EvaluationListComponent implements OnInit {

  constructor(
    private baseService : BaseService ,
    private evaluationService : EvaluationService,
    private router: Router,
  ) { }

  titleComponent:string;
  title_panel:string;
  banks:BankListItem[] = [];

  ngOnInit() {
    this.titleComponent = 'Evaluaciones';
    this.title_panel = 'Listado de Evaluaciones';
    this.baseService.changedComponentName(this.titleComponent);

    this.list();
  }

  //credEvaluations:EvaluationListItem[] = [];
  credEvaluations:EvaluationListItem[] = [];

  total = 10000000;
  bigCurrentPage: number = 1;
  maxSize: number = 5;
  size: number = 5;
  page: number = 1;
  status: string = '';

  

  filter_code:string = "";
  filter_dni:string = "";
  filter_ruc:string = "";
  filter_estado:string = "P";

  filtrar(){
    this.list( this.page , this.filter_code, this.filter_dni , this.filter_ruc , this.filter_estado );
  }
  list( page:number = 0,  code:string = "" , dni:string = ""  , ruc:string = "" , status:string = ""  ) {
    this.evaluationService.getAll( page ,code ,dni , ruc , status , this.size).subscribe( (data) => {
      if (data) {
        console.log(data);
        let datap:any = data;
        this.credEvaluations = [];
        datap.content.map( r => {
          this.credEvaluations.push({
            codOperation: r.codOperation,
            user : {
              fullName: r.user.fullName,
              email: r.user.email
            },
            dni: r.dni,
            ruc: r.ruc,
            creationDate: r.creationDate,
            resolutionDate: r.resolutionDate,
            resolutionUser: ( r.resolutionUser ? r.resolutionUser.email : '-'),
            status: r.status,
            id: r.id
          });
        });

        this.total = datap.totalElements;
        this.page = datap.number;

      }
    });
  }

  get(event, id: number) {
    const link = ['/dashboard/evaluations', id];
    this.router.navigate(link);
  }

  pageChanged(event: any): void {
    console.log(event.page);
    this.list( event.page -1  , this.filter_code, this.filter_dni , this.filter_ruc , this.filter_estado );
  }
}


/*
codOperation: "EV81d3d86d"
        user.fullName: "Antón Germano Soares Tchistiakov"
        user.email: "atch97@gmail.com"
        dni: "65346464"
        creationDate: "2019-09-04T13:12:27.926+0000"
        resolutionDate: null
        resolutionUser: userbData
        status: "P"
        
        */



// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/dashboard/evaluation/evaluation-list.component.ts